export default __webpack_public_path__ + "static/laptop-245c59e9299e23e2c90987cf190ce16f.png";